import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChPaginationComponent } from './ch-pagination.component';


export class ChPaginationModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  exports: [ChPaginationComponent],
  declarations: [ChPaginationComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
